import RYBConnectClasses from "../../../common/services/classes.service";
import { setFilterTopView } from "../views/filter-top.view";
import {
  setResultGridView,
  setToggleTableFunctionality,
} from "../views/result-grid.view";

const config = {
  attributes: true,
  childList: false,
  subtree: false,
  attributeFilter: ["style"],
};
let isProcessing = false;

export function onSetResult() {
  const target = document.querySelector(".result") as Element;
  const observer = new MutationObserver(function (mutations) {
    mutations.forEach((_mutation) => {
      if ($(target).is(":visible") && isProcessing === false) {
        processResult();
      }
    });
  });

  if ($(".step.step-result.active")) {
    processResult();
  }

  if (target) {
    observer.observe(target, config);
  }
}

export function processResult() {
  const classesManager = new RYBConnectClasses();

  classesManager
    .getFilteredDataByURLParams()
    .then((response) => {
      if (response.length) {
        $(".step-loading").hide();
        if ($(".ryb-nav .step.step-result").hasClass("active")) {
          $(".close-wizard-button.reset").removeClass("d-none");
          $(".ryb-nav .step").addClass("disabled");
          $(".close-wizard-button.back").addClass("d-none");
          $("#ryb-connect .bottom-controls").addClass("d-none");
          $("#ryb-connect").addClass("full-height");
        }
        setFilterTopView();
        setResultGridView(response);
        setToggleTableFunctionality();
      }
    })
    .catch((_error: any) => {
      $("#ryb-openings-result").html(
        `<p class="display:block">Error: Unable to fetch class openings.</p>`
      );
    })
    .finally(() => {
      isProcessing = false;
    });
}
